module.exports = __webpack_public_path__ + "static/media/seco-mind-ai-favicon.4cb09837.png";